module.exports = __webpack_public_path__ + "static/10-ea35766184da3370c372cbdb07965481.jpg";